// extracted by mini-css-extract-plugin
export default {"root":"ReviewContentText-module-root-SH6iG","enterMatchInfo":"ReviewContentText-module-enterMatchInfo-BaQ6Z"};